import { FiSearch } from 'react-icons/fi';
import toast from 'react-hot-toast';

import style from './Form.module.css';

interface FormProps {
  onSubmit: (value: string) => void;
}

export default function Form({ onSubmit }: FormProps) {
  const handlerForm = (formData: FormData) => {
    const value = formData.get('search') as string;

    if (value.trim().length > 0) {
      onSubmit(value);
    } else {
      toast.error('Value is empty');
    }
  };

  return (
    <form className={style.form} action={handlerForm}>
      <input
        className={style.input}
        placeholder="What do you want to write?"
        name="search"
        autoFocus
      />

      <button className={style.button} type="submit">
        <FiSearch size="16px" />
      </button>
    </form>
  );
}
